export default __webpack_public_path__ + "static/mgr-32822fccc5e71877fee6870c529bfdc0.jpeg";